var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.cxFcstGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.cxFcstGetErrors = $event
          }
        }
      }),
      _c(
        "v-toolbar",
        { attrs: { dark: "", dense: "", elevation: "0", color: "primary" } },
        [
          _c("v-toolbar-title", [_c("span", [_vm._v("Forecasts")])]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { text: "", dark: "", loading: _vm.convertingToPR },
              on: { click: _vm.createPR }
            },
            [_c("span", [_vm._v("Generate PR")])]
          ),
          _c("v-icon", [_vm._v("mdi-chart-timeline-variant")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          dense: "",
          loading: _vm.cxFcstGetting,
          items: _vm.computedCxFcst,
          headers: _vm.headers,
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "3", align: "right" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.customerList,
                            loading: _vm.customerGetting,
                            label: "Customer",
                            "item-value": "id",
                            clearable: "",
                            "item-text": "company"
                          },
                          model: {
                            value: _vm.customerId,
                            callback: function($$v) {
                              _vm.customerId = $$v
                            },
                            expression: "customerId"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "3", align: "right" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.fdPrgmCategoryList,
                            label: "Types",
                            clearable: "",
                            loading: _vm.fdPrgmCategoryGetting,
                            "item-value": "id",
                            "item-text": "description"
                          },
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "3", align: "right" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Date Start",
                            type: "date",
                            clearable: ""
                          },
                          model: {
                            value: _vm.dateStart,
                            callback: function($$v) {
                              _vm.dateStart = $$v
                            },
                            expression: "dateStart"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "3", align: "right" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Date End",
                            type: "date",
                            clearable: ""
                          },
                          model: {
                            value: _vm.dateEnd,
                            callback: function($$v) {
                              _vm.dateEnd = $$v
                            },
                            expression: "dateEnd"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.stock.description || "N/A"))]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(item.feedingProgramDetails.bags || "N/A") +
                        " " +
                        _vm._s(
                          item.feedingProgramDetails.bags > 1 ? "bags" : "bag"
                        )
                    )
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s((item.feedDetail.perBag || 0).phpFormat() || "N/A")
                    )
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(
                        (item.feedDetail.resellPerBag || 0).phpFormat() || "N/A"
                      )
                    )
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(
                        (
                          item.feedingProgramDetails.costBags || 0
                        ).phpFormat() || "N/A"
                      )
                    )
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(
                      _vm._s(
                        (
                          item.feedingProgramDetails.resellBags || 0
                        ).phpFormat() || "N/A"
                      )
                    )
                  ])
                ])
              ]
            }
          },
          {
            key: "body.append",
            fn: function() {
              return [
                _c("tr", [
                  _c("td", { attrs: { colspan: "4", align: "right" } }, [
                    _c("strong", [_vm._v("Total")])
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(_vm.totalCostBags.phpFormat()))
                  ]),
                  _c("td", { attrs: { align: "right" } }, [
                    _vm._v(_vm._s(_vm.totalResellBags.phpFormat()))
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }